import { BrowserRouter as Router, Routes, Route } from "react-router";
import { AuthProvider } from "@/react-app/contexts/AuthContext";
import { ThemeProvider } from "@/react-app/contexts/ThemeContext";
import HomePage from "@/react-app/pages/Home";
import DashboardPage from "@/react-app/pages/Dashboard";
import ReservationsPage from "@/react-app/pages/Reservations";
import RoomsPage from "@/react-app/pages/Rooms";
import InventoryPage from "@/react-app/pages/Inventory";
import ReportsPage from "@/react-app/pages/Reports";
import ExternalSalesPage from "@/react-app/pages/ExternalSales";
import RoomHistoryPage from "@/react-app/pages/RoomHistory";
import ProtectedRoute from "@/react-app/components/ProtectedRoute";

export default function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/reservations" element={<ProtectedRoute><ReservationsPage /></ProtectedRoute>} />
            <Route path="/rooms" element={<ProtectedRoute><RoomsPage /></ProtectedRoute>} />
            <Route path="/inventory" element={<ProtectedRoute><InventoryPage /></ProtectedRoute>} />
            <Route path="/external-sales" element={<ProtectedRoute><ExternalSalesPage /></ProtectedRoute>} />
            <Route path="/room-history" element={<ProtectedRoute><RoomHistoryPage /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
          </Routes>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}
